import React from 'react';

// Standard numbered document header: SEC. NN / LABEL over a serif title.
function SectionHeader({ index, label, title }) {
    return (
        <header className="doc-header reveal">
            <div className="doc-header-meta">
                <span className="doc-header-index">SEC. {index}</span>
                <span className="doc-header-label">{label}</span>
            </div>
            <h2 className="doc-header-title">
                {title}
                <span className="accent">.</span>
            </h2>
        </header>
    );
}

export default SectionHeader;
